export default __webpack_public_path__ + "static/media/BKK.af8c06ff.png";